<template>
  <section class="container-wrapper thank-you-page">
    <h1 class="thank-you-page__title">
      {{ title }}
    </h1>
    <p class="thank-you-page__text">
      {{ text }}
    </p>
    <div class="thank-you-page__button-wrapper">
      <BaseButton
        class="thank-you-page__button"
        @click="navigateHome"
      >
        {{ buttonText }}
      </BaseButton>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import { get } from 'lodash'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'NotFoundPage',
    computed: {
      ...mapState(['general']),
      title () {
        return get(this, 'general.notFound.title')
      },
      text () {
        return get(this, 'general.notFound.text')
      },
      buttonText () {
        return get(this, 'general.notFound.buttonText')
      }
    },
    methods: {
      navigateHome () {
        let query = {}

        if (this.$store.state.currentLang !== DEFAULT_LANG) {
          query = { lang: this.$store.state.currentLang }
        }
        this.$router.push({ path: '/', query: query })
      }
    }
  }
</script>

<style lang="scss">
.thank-you-page {
  max-width: 495px;

  @include mobile {
    max-width: 290px;
  }

  &__title {
    text-align: center;
  }

  &__text {
    text-align: center;
  }

  &__button {
    &-wrapper {
      display: flex;
      justify-content: center;
    }

    margin-top: 50px;

    @include mobile {
      margin-top: 25px;
    }
  }
}
</style>
